import { render, staticRenderFns } from "./EventContext.vue?vue&type=template&id=18a49d09&scoped=true"
import script from "./EventContext.vue?vue&type=script&lang=js"
export * from "./EventContext.vue?vue&type=script&lang=js"
import style0 from "./EventContext.vue?vue&type=style&index=0&id=18a49d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a49d09",
  null
  
)

export default component.exports